import { render, staticRenderFns } from "./reset.vue?vue&type=template&id=22facd62&"
import script from "./reset.vue?vue&type=script&lang=ts&"
export * from "./reset.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports